import { createThemeStore, familyThemeConfig, type ThemeConfig } from "@jkast90/kast-common/theme";

/**
 * The family's four choices (System, Light, Dark, High contrast), saved in
 * this browser under the key the site has always used. A saved `light`,
 * `dark` or `system` still holds; nothing saved, or anything else, opens the
 * site on Light (the owner's default; the OS's light or dark is one tap away
 * on System). index.html carries `themeBootScript(themeConfig)` so the page
 * paints in the right theme; the store (created when the entry imports this)
 * then keeps "system" following the OS and other tabs in step.
 */
export const themeConfig: ThemeConfig = {
  storageKey: "hnt_theme",
  defaultMode: "light",
  // The browser bar takes the site's cream or forest-black.
  ...familyThemeConfig({ light: "#f8f6f0", dark: "#121811" }),
};

export const themeStore = createThemeStore(themeConfig);
